/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
const permission = {
  state: {
    routers: [],
    addRouters: [],
    secondRouters:JSON.parse(sessionStorage.getItem(process.env.NODE_ENV+"lastSecondRouters"))||[],
    buttonPageObj:JSON.parse(sessionStorage.getItem(process.env.NODE_ENV+"buttonPage"))||{},//拥有页面权限的按钮
    routerKeyData:{}
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = [].concat(routers)
    },
    SET_SECONDROUTERS:(state,routers)=>{
    	sessionStorage.setItem(process.env.NODE_ENV+"lastSecondRouters",JSON.stringify(routers))
    	state.secondRouters = routers||[]
    },
    SET_buttonPageObj: (state, list) => {
      try {
        state.buttonPageObj = {};
        list.forEach(item=>{
          state.buttonPageObj[item]=true;
        })
        sessionStorage.setItem(process.env.NODE_ENV+"buttonPage",JSON.stringify(state.buttonPageObj))
      } catch (error) {
        console.log("===11111=====",error)
      }
    	
    },
    SET_ROUTERKEYDATA: (state, routerKeyData) => {
      state.routerKeyData = routerKeyData;
    }
  }
}

export default permission
